import {
  Grid,
  MenuItem,
  Modal,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import UploadDocument from "../Generics/UploadDocument";
import ModalHelper from "../Generics/ModalHelper";
import "../../assets/css/Incarico.css";
import "../../assets/css/text.css";
import { useSelector } from "react-redux";

const IncaricoComponent = ({
  practice = {
    Incarico: {
      Nome_pratica: "",
      Team_riferimento: { id: null, name: null, product: [] },
      Prodotto_richiesto: {},
      responsabile_pratica: "",
      SOB: "",
      valore_associato_pratica: "",
    },
  },
  onPracticeUpdate,
  documentAssignment,
  uploadFiles,
  documentPractice,
  removeFilePractice,
  errors,
  practice_object,
  errorFileLarge,
}) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [modalObjectInfo, setModalObjectInfo] = useState({});

  const team = useSelector((state) => state.user?.redux_object?.team);

  const product = useSelector((state) => state.user?.redux_object.products);

  const teamArray = Array.isArray(team) ? team : Object.values(team);

  const sortedTeamArray = teamArray.sort((a, b) =>
    a.name.localeCompare(b.name)
  );

  const altri_contatti_email_notification = [
    { value: "No", label: "No" },
    { value: 1, label: "1 lettore" },
    { value: 2, label: "2 lettori" },
    { value: 3, label: "3 lettori" },
    { value: 4, label: "4 lettori" },
    { value: 5, label: "5 lettori" },
  ];

  // email cc notifica
  const [emailFields, setEmailFields] = useState([{ id: 1 }]);

  const filterProductsByTeamId = (teamId) => {
    if (!teamId || !product) return [];

    return Object.values(product).filter((item) => item.team_id === teamId);
  };

  const handlePracticeChange = (name, value) => {
    const updatedPractice = {
      ...practice,
      Incarico: {
        ...practice?.Incarico,
        [name]: value,
      },
    };

    if (name === "altri_contatti_email_notification") {
      const currentReaders = updatedPractice?.Incarico?.readers_email || [];

      const updatedReaders = currentReaders.slice(0, value);

      updatedPractice.Incarico.readers_email = updatedReaders;
    }

    if (name === "Team_riferimento") {
      updatedPractice.Incarico.Prodotto_richiesto = {};
      updatedPractice.AML = {};
      localStorage.setItem("AML", null);
    }

    onPracticeUpdate(updatedPractice);
  };

  const handleProductChange = (name, value) => {
    const updatedPractice = {
      ...practice,
      Incarico: {
        ...practice?.Incarico,
        [name]: value,
      },
    };

    if (name === "Prodotto_richiesto") {
      updatedPractice.AML = {};
      localStorage.setItem("AML", null);
    }
    onPracticeUpdate(updatedPractice);
  };

  const handleModalClick = (objectInfo) => {
    setModalObjectInfo(objectInfo);
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setModalObjectInfo({});
  };

  const tooltipContent = {
    pratica: {
      infoTitle: "Nome della pratica",
      description:
        "Il nome della pratica deve essere così composto: Cliente / Prodotto + Specifica eventuale.",
      descriptionBis:
        "Esempi: Mario Rossi / Costituzione di startup innovativa; Alfa Srl / Contratto di investimento Beta Spa.",
    },
    responsabile_pratica: {
      infoTitle: "Responsabile della pratica",
      description:
        "Il responsabile della pratica è il professionista LEXIA a cui è affidato l'incarico.",
    },
    SOB: {
      infoTitle: "SOB",
      description:
        "Il SOB (Source of Business) è la persona da cui originano cliente e incarico.",
    },
    documenti_incarico: {
      infoTitle: "Documenti di conferma dell'incarico",
      description: (
        <Typography>
          Esempi di documenti di conferma dell'incarico:
          <ul style={{ marginTop: "5px" }}>
            <li>lettera di incarico firmata</li>
            <li>corrispondenza e-mail provante l'accettazione del cliente.</li>
          </ul>
        </Typography>
      ),
    },
    altri_contatti_email_notification: {
      infoTitle: "Vuoi aggiungere dei lettori?",
      description: (
        <>
          <Typography>
            {" "}
            Il lettore è la persona che riceverà le notifiche relative
            all'approvazione di questa pratica.{" "}
          </Typography>
          <Typography>Puoi inserire al massimo 5 lettori.</Typography>
        </>
      ),
    },
  };

  const valoreAssociatoOptions = [
    "Non determinabile o non applicabile",
    "Fino a €1.000",
    "Tra €1.001 e €2.500",
    "Tra €2.501 e €5.000",
    "Tra €5.001 e €10.000",
    "Tra €10.001 e €25.000",
    "Tra €25.001 e €50.000",
    "Tra €50.001 e €100.000",
    "Tra €100.001 e €200.000",
    "Tra €200.001 e €350.000",
    "Tra €350.001 e €500.000",
    "Tra €500.001 e €750.000",
    "Tra €750.001 e €1.000.000",
    "Tra €1.000.001 e €2.500.000",
    "Tra €2.500.001 e €5.000.000",
    "Tra €5.000.001 e €10.000.000",
    "Tra €10.000.001 e €20.000.000",
    "Tra €20.000.001 e €50.000.000",
    "Tra €50.000.001 e €100.000.000",
    "Tra €100.000.001 e €300.000.000",
    "Tra €300.000.001 e €500.000.000",
    "Sopra €500.000.000",
  ];

  const filteredProducts = filterProductsByTeamId(
    practice?.Incarico?.Team_riferimento?.id
  );

  return (
    <>
      <Grid
        container
        style={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Grid
          item
          xs={11}
          sm={10}
          style={{
            overflowY: "auto",
            marginTop: "30px",
          }}
        >
          {/* Title */}
          <Grid
            xs={12}
            spacing={4}
            item
            container
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Grid item xs={11} md={4}>
              <Typography className="color-blue-dark title-step">
                Incarico
              </Typography>
            </Grid>

            <Grid item xs={11} md={4} style={{ paddingTop: "0px" }}></Grid>

            <Grid item xs={11} md={4} style={{ paddingTop: "0px" }}></Grid>
          </Grid>

          <Grid
            xs={12}
            spacing={4}
            item
            container
            style={{ display: "flex", justifyContent: "center" }}
          >
            {/* Nome pratica */}
            <Grid
              item
              xs={11}
              md={4}
              className="marginTop-input"
              sx={{
                marginTop: { xs: "20px !important", md: "32px !important" },
              }}
            >
              <div style={{ display: "flex", height: "20px" }}>
                <Typography className="color-blue-dark title-input">
                  Nome della pratica
                </Typography>
                <div
                  className="icon-modal-info"
                  style={{ marginLeft: "10px", cursor: "pointer" }}
                  onClick={() => handleModalClick(tooltipContent.pratica)}
                />
              </div>

              <TextField
                style={{
                  marginTop: "10px",
                }}
                error={errors.includes("Nome_pratica")}
                placeholder="Inserisci"
                variant="outlined"
                fullWidth
                name="Nome_pratica"
                value={practice?.Incarico?.Nome_pratica || ""}
                onChange={(e) =>
                  handlePracticeChange(e.target.name, e.target.value)
                }
              />
            </Grid>

            {/* Dipartimento Elibra */}
            <Grid item xs={11} md={4} className="marginTop-input">
              <div style={{ display: "flex", height: "20px" }}>
                <Typography className="color-blue-dark title-input">
                  Dipartimento Elibra
                </Typography>
              </div>

              <Select
                value={practice?.Incarico?.Team_riferimento?.name || ""}
                error={errors.includes("Team_riferimento")}
                onChange={(e) => {
                  const selectedTeam = sortedTeamArray.find(
                    (item) => item.name === e.target.value
                  );
                  handlePracticeChange("Team_riferimento", selectedTeam);
                }}
                displayEmpty
                fullWidth
                style={{
                  marginTop: "10px",
                }}
              >
                <MenuItem value="">
                  <span style={{ color: "#abb0b6" }}>Seleziona</span>
                </MenuItem>
                {sortedTeamArray &&
                  sortedTeamArray.map((item, index) => (
                    <MenuItem key={index} value={item.name}>
                      {item.name}
                    </MenuItem>
                  ))}
              </Select>
            </Grid>

            {/* Prodotto richiesto */}
            <Grid item xs={11} md={4} className="marginTop-input">
              <div style={{ display: "flex", height: "20px" }}>
                <Typography className="color-blue-dark title-input">
                  Prodotto richiesto
                </Typography>
              </div>

              <Select
                value={practice?.Incarico?.Prodotto_richiesto?.name || ""}
                error={errors.includes("Prodotto_richiesto")}
                onChange={(e) => {
                  const selectedProduct = filteredProducts.find(
                    (item) => item.name === e.target.value
                  );
                  if (selectedProduct) {
                    handleProductChange("Prodotto_richiesto", {
                      AML_rischio_default: selectedProduct.AML_rischio_default,
                      AML_tipo_default: selectedProduct.AML_tipo_default,
                      AML_scelta_default: selectedProduct.AML_scelta_default,
                      name: selectedProduct.name,
                    });
                  }
                }}
                displayEmpty
                fullWidth
                style={{
                  marginTop: "10px",
                }}
              >
                <MenuItem value="">
                  <span style={{ color: "#abb0b6" }}>Seleziona</span>
                </MenuItem>
                {practice?.Incarico?.Team_riferimento?.product
                  ?.sort((a, b) => {
                    if (a.name === "Altro") return 1;
                    if (b.name === "Altro") return -1;
                    return a.name.localeCompare(b.name);
                  })
                  .map((item, index) => (
                    <MenuItem key={index} value={item.name}>
                      {item.name}
                    </MenuItem>
                  ))}
              </Select>
            </Grid>
          </Grid>

          <Grid
            xs={12}
            spacing={4}
            item
            container
            style={{ display: "flex", justifyContent: "center" }}
          >
            {/* Valore associato */}
            <Grid
              item
              xs={11}
              md={4}
              className="marginTop-input"
              sx={{
                marginTop: { xs: "30px !important", md: "30px !important" },
              }}
            >
              <div style={{ display: "flex", height: "20px" }}>
                <Typography className="color-blue-dark title-input">
                  Valore associato alla pratica
                </Typography>
              </div>

              <Select
                value={practice?.Incarico?.valore_associato_pratica || ""}
                error={errors.includes("valore_associato_pratica")}
                onChange={(e) =>
                  handlePracticeChange(
                    "valore_associato_pratica",
                    e.target.value
                  )
                }
                displayEmpty
                fullWidth
                style={{
                  marginTop: "10px",
                  borderColor: errors.includes("valore_associato_pratica")
                    ? "red"
                    : "initial",
                }}
              >
                <MenuItem value="">
                  <span style={{ color: "#abb0b6" }}>Seleziona</span>
                </MenuItem>
                {valoreAssociatoOptions.map((option, index) => (
                  <MenuItem key={index} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </Select>
            </Grid>

            {/* Responsabile */}
            <Grid item xs={11} md={4} className="marginTop-input">
              <div style={{ display: "flex", height: "20px" }}>
                <Typography className="color-blue-dark title-input">
                  Responsabile della pratica
                </Typography>
                <div
                  className="icon-modal-info"
                  style={{ marginLeft: "10px", cursor: "pointer" }}
                  onClick={() =>
                    handleModalClick(tooltipContent.responsabile_pratica)
                  }
                />
              </div>

              <TextField
                style={{
                  marginTop: "10px",
                }}
                error={errors.includes("responsabile_pratica")}
                variant="outlined"
                placeholder="Inserisci"
                name="responsabile_pratica"
                value={practice?.Incarico?.responsabile_pratica || ""}
                onChange={(e) =>
                  handlePracticeChange(e.target.name, e.target.value)
                }
                fullWidth
              />
            </Grid>

            {/* SOB */}
            <Grid item xs={11} md={4} className="marginTop-input">
              <div style={{ display: "flex", height: "20px" }}>
                <Typography className="color-blue-dark title-input">
                  SOB
                </Typography>
                <div
                  className="icon-modal-info"
                  style={{ marginLeft: "10px", cursor: "pointer" }}
                  onClick={() => handleModalClick(tooltipContent.SOB)}
                />
              </div>

              <TextField
                style={{
                  marginTop: "10px",
                }}
                error={errors.includes("SOB")}
                variant="outlined"
                placeholder="Inserisci"
                name="SOB"
                value={practice?.Incarico?.SOB || ""}
                onChange={(e) =>
                  handlePracticeChange(e.target.name, e.target.value)
                }
                fullWidth
              />
            </Grid>
          </Grid>

          {/* Upload */}
          <Grid
            container
            xs={12}
            item
            style={{ display: "flex", justifyContent: "center" }}
          >
            <Grid
              xs={11}
              md={12}
              item
              style={{
                marginTop: "30px",
                marginBottom: "0px",
              }}
            >
              <div style={{ display: "flex", height: "20px" }}>
                <Typography
                  className="color-blue-dark title-input"
                  style={{ marginBottom: "8px" }}
                >
                  Documenti di conferma dell'incarico
                </Typography>
                <div
                  className="icon-modal-info"
                  style={{ marginLeft: "10px", cursor: "pointer" }}
                  onClick={() =>
                    handleModalClick(tooltipContent.documenti_incarico)
                  }
                />
              </div>

              <UploadDocument
                documentPractice={documentPractice}
                documentAssignment={documentAssignment}
                removeFilePractice={removeFilePractice}
                errors={errors}
                uploadFiles={uploadFiles}
                practice_object={practice_object}
                errorFileLarge={errorFileLarge}
              />
            </Grid>
          </Grid>

          <Grid
            xs={12}
            spacing={4}
            item
            container
            sx={{
              marginTop: { xs: "0px !important", md: "0px !important" },
              marginBottom: "50px",
              display: "flex",
              justifyContent: { xs: "center", md: "start" },
            }}
          >
            {/* Email CC notifiche pratica */}
            <Grid item xs={11} md={4}>
              <div style={{ display: "flex", height: "20px" }}>
                <Typography className="color-blue-dark title-input">
                  Vuoi aggiungere uno o più lettori?
                </Typography>
                <div
                  className="icon-modal-info"
                  style={{ marginLeft: "10px", cursor: "pointer" }}
                  onClick={() =>
                    handleModalClick(
                      tooltipContent.altri_contatti_email_notification
                    )
                  }
                />
              </div>

              <Select
                value={
                  practice?.Incarico?.altri_contatti_email_notification || ""
                }
                onChange={(e) =>
                  handlePracticeChange(
                    "altri_contatti_email_notification",
                    e.target.value
                  )
                }
                error={errors.includes("altri_contatti_email_notification")}
                displayEmpty
                fullWidth
                style={{ marginTop: "10px" }}
              >
                <MenuItem value="">
                  <span style={{ color: "#abb0b6" }}>Seleziona</span>
                </MenuItem>
                {altri_contatti_email_notification.map((item, index) => (
                  <MenuItem key={index} value={item.value}>
                    {item.label}
                  </MenuItem>
                ))}
              </Select>
            </Grid>

            {practice?.Incarico?.altri_contatti_email_notification !== "No" && (
              <>
                {Array.from(
                  {
                    length:
                      practice?.Incarico?.altri_contatti_email_notification,
                  },
                  (_, index) => {
                    return (
                      <Grid
                        key={index}
                        sx={{
                          paddingTop: {
                            xs: "32px !important",
                            md: "32px !important",
                          },
                        }}
                        item
                        xs={11}
                        md={4}
                      >
                        <>
                          <Typography className="color-blue-dark title-input">
                            {index === 0
                              ? "E-mail primo lettore"
                              : index === 1
                                ? "E-mail secondo lettore"
                                : index === 2
                                  ? "E-mail terzo lettore"
                                  : index === 3
                                    ? "E-mail quarto lettore"
                                    : index === 4
                                      ? "E-mail quinto lettore"
                                      : ""}
                          </Typography>

                          <div
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <TextField
                              style={{ marginTop: "10px" }}
                              type="email"
                              placeholder="Inserisci"
                              variant="outlined"
                              fullWidth
                              value={
                                practice?.Incarico?.readers_email?.[index] || ""
                              }
                              onChange={(e) => {
                                const updatedEmails = [
                                  ...(practice?.Incarico?.readers_email || []),
                                ];
                                updatedEmails[index] = e.target.value;
                                handlePracticeChange(
                                  "readers_email",
                                  updatedEmails
                                );
                              }}
                              error={
                                errors.includes(`readers_email_${index}`) ||
                                errors.includes(
                                  `readers_email_${index}_invalid`
                                )
                              }
                              helperText={
                                errors.includes(
                                  `readers_email_${index}_invalid`
                                )
                                  ? "Indirizzo e-mail non valido"
                                  : ""
                              }
                              FormHelperTextProps={{
                                style: {
                                  color: "#bc2957",
                                },
                              }}
                            />
                          </div>
                        </>
                      </Grid>
                    );
                  }
                )}
                <Grid item xs={11} md={4}></Grid>
              </>
            )}
          </Grid>
        </Grid>
      </Grid>

      <Modal open={modalOpen} onClose={handleCloseModal}>
        <div>
          <ModalHelper
            onClose={handleCloseModal}
            modalObjectInfo={modalObjectInfo}
          />
        </div>
      </Modal>
    </>
  );
};

export default IncaricoComponent;
